import { useTranslation } from "react-i18next";
import { useBrand } from "@webuild-ai/react-auth";

import DefaultLayout from "@/layouts/default"; // Import DefaultLayout
import { title, subtitle } from "@/components/primitives";
import { IconLoading } from "@/components/icons";
import { useTheme } from "@/hooks/use-theme";

const LoadingPage = () => {
  const { t } = useTranslation();
  const { brand } = useBrand();
  const { theme } = useTheme();

  const BrandLogo = theme === "dark" && brand.logoDark ? brand.logoDark : brand.logo;

  return (
    <DefaultLayout>
      <section className="flex flex-col items-center justify-center gap-4 py-8 md:py-10">
        <div className="inline-block max-w-lg text-center justify-center">
          {brand.showLogo ? (
            <BrandLogo className="mx-auto mb-10" size={brand.menuItemsIconSize || 60} />
          ) : (
            <>
              <span className={title()}>{brand.name}&nbsp;</span>
              <span className={`${subtitle({ class: "mt-4" })} text-primary`}>
                {t(brand.subtitle)}
              </span>
            </>
          )}
          <br />
          <br />
          <br />
          <br />
          <br />
          <div className="loading-animation flex flex-col items-center">
            <IconLoading />
            <p className="mt-4 text-primary">{t("Loading...")}</p>
          </div>
        </div>{" "}
        {/* Closing the div element */}
      </section>
    </DefaultLayout>
  );
};

export default LoadingPage;
